import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { UPDATES_TYPES } from '@shared/constants/updates-types.const';
import { RootApplicationState } from './root.reducer';
import { AppUrlOpenAction, InitLocalDBSuccess, UpdateDataEvent } from './root.actions';

export const supportRootStoreEntities: string[] = [UPDATES_TYPES.Employee.type, UPDATES_TYPES.Invoice.type, UPDATES_TYPES.Company.type];

@Injectable()
export class RootApplicationStateFacade {
  constructor(private store: Store<RootApplicationState>) {}

  public initLocalDBSuccess(): void {
    this.store.dispatch(InitLocalDBSuccess());
  }

  public updateData(updateData: unknown, updateDataType: string): void {
    this.store.dispatch(UpdateDataEvent({ updateData, updateDataType }));
  }

  public appUrlOpen(url: URL): void {
    this.store.dispatch(AppUrlOpenAction({ url }));
  }
}
